import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import posService from '../../services/posService';

export const fetchSalesPoints = createAsyncThunk(
  'pos/fetchSalesPoints',
  async (params, { rejectWithValue }) => {
    try {
      const response = await posService.getSalesPoints(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCashSales = createAsyncThunk(
  'pos/fetchCashSales',
  async (params, { rejectWithValue }) => {
    try {
      const response = await posService.getCashSales(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchShifts = createAsyncThunk(
  'pos/fetchShifts',
  async (params, { rejectWithValue }) => {
    try {
      const response = await posService.getShifts(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSettlements = createAsyncThunk(
  'pos/fetchSettlements',
  async (params, { rejectWithValue }) => {
    try {
      const response = await posService.getSettlements(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchReturns = createAsyncThunk(
  'pos/fetchReturns',
  async (params, { rejectWithValue }) => {
    try {
      const response = await posService.getReturns(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const posSlice = createSlice({
  name: 'pos',
  initialState: {
    salesPoints: [],
    cashSales: [],
    shifts: [],
    settlements: [],
    returns: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearPosError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesPoints.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchSalesPoints.fulfilled, (state, action) => { state.isLoading = false; state.salesPoints = action.payload.results || action.payload; })
      .addCase(fetchSalesPoints.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(fetchCashSales.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchCashSales.fulfilled, (state, action) => { state.isLoading = false; state.cashSales = action.payload.results || action.payload; })
      .addCase(fetchCashSales.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(fetchShifts.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchShifts.fulfilled, (state, action) => { state.isLoading = false; state.shifts = action.payload.results || action.payload; })
      .addCase(fetchShifts.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(fetchSettlements.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchSettlements.fulfilled, (state, action) => { state.isLoading = false; state.settlements = action.payload.results || action.payload; })
      .addCase(fetchSettlements.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(fetchReturns.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchReturns.fulfilled, (state, action) => { state.isLoading = false; state.returns = action.payload.results || action.payload; })
      .addCase(fetchReturns.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
  },
});

export const { clearPosError } = posSlice.actions;
export default posSlice.reducer;
